import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { cx } from 'linaria';
import { Children, cloneElement } from 'react';
import { presetDecorator, Preset, isEmptyArray, isDocNodeEmpty, isString } from '@remirror/core';
import { PlaceholderExtension } from '@remirror/extension-placeholder';
import { ReactComponentExtension } from '@remirror/extension-react-component';
import { ReactSSRExtension } from '@remirror/extension-react-ssr';
import { getElementProps } from '@remirror/react-utils';

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ReactPreset = (_dec = /*#__PURE__*/presetDecorator({
  defaultOptions: /*#__PURE__*/_objectSpread( /*#__PURE__*/_objectSpread({}, ReactSSRExtension.defaultOptions), PlaceholderExtension.defaultOptions),
  staticKeys: ['transformers']
}), /*#__PURE__*/_dec(_class = class ReactPreset extends Preset {
  get name() {
    return 'react';
  }
  /**
   * No properties are defined so this can be ignored.
   */


  onSetOptions(parameter) {
    var pickChanged = parameter.pickChanged;
    var placeholderOptions = pickChanged(['emptyNodeClass', 'placeholder']);

    if (!isEmptyArray(placeholderOptions)) {
      this.getExtension(PlaceholderExtension).setOptions(placeholderOptions);
    }
  }

  createExtensions() {
    var _this$options = this.options,
        transformers = _this$options.transformers,
        emptyNodeClass = _this$options.emptyNodeClass,
        placeholder = _this$options.placeholder;
    var placeholderExtension = new PlaceholderExtension({
      emptyNodeClass,
      placeholder
    });
    this.addSSRToPlaceholder(placeholderExtension);
    var reactComponentExtension = new ReactComponentExtension();
    return [new ReactSSRExtension({
      transformers
    }), placeholderExtension, reactComponentExtension];
  }

  addSSRToPlaceholder(extension) {
    /**
     * Add a class and props to the root element if the document is empty.
     */
    extension.createSSRTransformer = () => {
      return (element, state) => {
        var _state;

        state = (_state = state) !== null && _state !== void 0 ? _state : this.extensionStore.getState();
        var _extension$options = extension.options,
            emptyNodeClass = _extension$options.emptyNodeClass,
            placeholder = _extension$options.placeholder;

        var _getElementProps = getElementProps(element),
            children = _getElementProps.children;

        if (Children.count(children) > 1 || !isDocNodeEmpty(state.doc)) {
          return element;
        }

        var properties = getElementProps(children);
        return /*#__PURE__*/cloneElement(element, {}, /*#__PURE__*/cloneElement(children, {
          placeholder,
          className: cx(isString(properties.className) && properties.className, emptyNodeClass),
          'data-placeholder': placeholder
        }));
      };
    };
  }

}) || _class);

export { ReactPreset };
